import { ArrowUp, ArrowDown } from 'lucide-preact';
import type { ComponentChildren } from 'preact';
import { BlockInfoIcon } from '../ui/BlockInfoIcon';
import { cn } from '../ui/types';

interface SimpleCardProps {
  title: string;
  infoBlockId?: string;
  value: string;
  periodLabel?: string;
  footnote?: string;
  trend?: string;
  trendType?: 'positive' | 'negative' | 'neutral';
  showTrend?: boolean;
  headerIcon?: ComponentChildren;
  loading?: boolean;
  className?: string;
  variant?: 'default' | 'warning' | 'risk';
}

export const SimpleCard = ({
  title,
  infoBlockId,
  value,
  periodLabel = 'TTM',
  footnote,
  trend = '',
  trendType = 'neutral',
  showTrend = false,
  headerIcon,
  loading = false,
  className,
  variant = 'default',
}: SimpleCardProps) => {
  return (
    <article
      className={cn(
        'ui-kpi-card',
        variant === 'warning' && 'ui-kpi-card--warning',
        variant === 'risk' && 'ui-kpi-card--risk',
        className,
      )}
    >
      <div className="ui-kpi-card__header">
        <div className="ui-kpi-card__title-row">
          <h3 className="ui-kpi-card__label">{title}</h3>
          {infoBlockId && <BlockInfoIcon blockId={infoBlockId} />}
        </div>
        {headerIcon && <div className="ui-kpi-card__header-icon">{headerIcon}</div>}
        {showTrend && trend && (
          <div className={cn('ui-kpi-card__trend', `ui-kpi-card__trend--${trendType}`)}>
            {trendType === 'positive' ? (
              <ArrowUp size={12} aria-hidden />
            ) : trendType === 'negative' ? (
              <ArrowDown size={12} aria-hidden />
            ) : null}
            <span>{trend}</span>
          </div>
        )}
      </div>
      <div className="ui-kpi-card__value">
        {loading ? <span className="ui-kpi-card__loading">Loading...</span> : value}
      </div>
      {periodLabel && !loading && <div className="ui-kpi-card__period">{periodLabel}</div>}
      {footnote && !loading && <div className="ui-kpi-card__footnote">{footnote}</div>}
    </article>
  );
};
